// WorkHistoryComponent.js (Your React Component)

import React, { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API_BASE_URL } from "../../components/APIs";
import { Heading, Box, Text, Spinner } from "@chakra-ui/react";

function WorkHistoryComponent() {
  const [workHistory, setWorkHistory] = useState([]);
  const [loading, setLoading] = useState(true);
  const [lastUpdated, setLastUpdated] = useState(new Date());

  // Fetch work history data
  const fetchWorkHistory = useCallback(async () => {
    try {
      const uid = sessionStorage.getItem("uid");
      console.log("Fetching work history data...", new Date().toLocaleTimeString());

      const response = await axios.post(API_BASE_URL + "application/getUserWorkHistory", {
        user_id: uid
      });
console.table(response);
      setWorkHistory(response?.data || []);
      setLastUpdated(new Date());
      setLoading(false);
    } catch (error) {
      console.error("Error fetching work history data: ", error);
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Initial fetch
    fetchWorkHistory();

    // Set up interval for automatic refresh
    const intervalId = setInterval(() => {
      fetchWorkHistory();
    }, 1000); // Refresh every 1 seconds

    // Cleanup interval on component unmount
    return () => {
      clearInterval(intervalId);
    };
  }, [fetchWorkHistory]);

  // Optional: Manual refresh function
  const handleManualRefresh = () => {
    setLoading(true);
    fetchWorkHistory();
  };

  return (
    <Box p={4}>
      {/* Header with last updated time and refresh button */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <Heading size="lg">Work History</Heading>
        <Box display="flex" alignItems="center" gap={3}>
          <Text fontSize="sm" color="gray.600">
            Last updated: {lastUpdated.toLocaleTimeString()}
          </Text>
          <button
            onClick={handleManualRefresh}
            style={{
              padding: '8px 16px',
              backgroundColor: '#3182CE',
              color: 'white',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer',
              fontSize: '14px'
            }}
            disabled={loading}
          >
            {loading ? 'Refreshing...' : 'Refresh'}
          </button>
        </Box>
      </Box>

      {loading ? (
        <Box textAlign="center" py={8}>
          <Spinner size="xl" color="blue.500" />
          <Text mt={2}>Loading work history...</Text>
        </Box>
      ) : Array.isArray(workHistory) && workHistory.length > 0 ? (
        <Box>
          <Text mb={4} color="green.600" fontWeight="medium">
            Found {workHistory.length} work history record(s)
          </Text>
          <Box style={{ listStyle: 'none' }}>
            {workHistory.map((work, index) => (
              <Box
                key={index}
                p={4}
                mb={4}
                border="1px solid #E2E8F0"
                borderRadius="md"
                bg="white"
                boxShadow="sm"
              >
                <Text fontSize="lg" fontWeight="bold" mb={2}>
                  {work.employer_name}
                </Text>
                <Text><strong>Position Held:</strong> {work.position_held}</Text>
                <Text><strong>Experience:</strong> {work.experience}</Text>
                <Text><strong>Reason for Leave:</strong> {work.reason_for_leave}</Text>
                <Text><strong>Start Date:</strong> {work.start_date}</Text>
                <Text><strong>End Date:</strong> {work.end_date}</Text>
              </Box>
            ))}
          </Box>
        </Box>
      ) : (
        <Box textAlign="center" py={8}>
          <Text fontSize="lg" color="gray.600">
            No work history data available.
          </Text>
        </Box>
      )}
    </Box>
  );
}

export default WorkHistoryComponent;